import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Bluetooth = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Bluetooth" {...props}>
    <path d="M11.5527 2.10547C11.8915 1.93611 12.2966 1.97304 12.5996 2.2002L18.5996 6.7002L18.6895 6.77539C18.8866 6.96295 19 7.22456 19 7.5C18.9999 7.77542 18.8866 8.03709 18.6895 8.22461L18.5996 8.2998L13.957 11.7803L18.6445 15.7354L18.7275 15.8135C18.9083 16.005 19.0075 16.262 19 16.5283C18.9912 16.8328 18.8433 17.117 18.5996 17.2998L12.5996 21.7998C12.2966 22.0269 11.8914 22.0638 11.5527 21.8945C11.214 21.7252 11.0001 21.3787 11 21V13.999L6.59961 17.2998C6.15784 17.6309 5.53153 17.5412 5.2002 17.0996C4.86899 16.6578 4.95869 16.0315 5.40039 15.7002L10.7471 11.6895L5.35547 7.13965L5.28027 7.06934C4.9281 6.70516 4.90191 6.12616 5.23535 5.73047C5.56927 5.33471 6.14505 5.2627 6.56348 5.54883L6.64453 5.61035L11 9.28516V3L11.0098 2.85938C11.0555 2.53722 11.2565 2.25364 11.5527 2.10547ZM13 19L16.3945 16.4541L13 13.5889V19ZM13 10L16.334 7.5L13 4.99902V10Z" fill="#000" />
  </StyledIcon>
));

Bluetooth.displayName = 'Bluetooth';

export { Bluetooth };
